import VerificationRequest from './VerificationRequest';

export default VerificationRequest;
